__turbopack_context__.v({
  "caption": "Tfa9WW_caption",
  "card": "Tfa9WW_card",
  "imageContainer": "Tfa9WW_imageContainer",
  "imageContainerCentered": "Tfa9WW_imageContainerCentered",
  "textContainer": "Tfa9WW_textContainer",
  "title": "Tfa9WW_title",
});
